module.exports = __webpack_public_path__ + "img/close_black.9666a658.svg";